// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Nunito-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Nunito-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Nunito Font — used for CM Central branding
   ============================================================ */
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 800;
  font-style: normal;
}
/* ============================================================
   DatePicker — Orange Brand Overrides
   Applied globally to all react-datepicker instances
   ============================================================ */
/* Z-index fix for popper to appear above tables and headers */
.react-datepicker-popper {
  z-index: 9999 !important;
}

/* Header */
.react-datepicker {
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
  font-family: inherit !important;
  overflow: hidden;
}

.react-datepicker__header {
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa !important;
  padding-top: 12px !important;
}

.react-datepicker__current-month {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #1e293b !important;
}

.react-datepicker__day-name {
  color: #94a3b8 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
}

/* Navigation arrows */
.react-datepicker__navigation-icon::before {
  border-color: #e85b28 !important;
}

.react-datepicker__navigation:hover *::before {
  border-color: #c44a1e !important;
}

/* Day cells */
.react-datepicker__day {
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  transition: all 0.1s !important;
}

.react-datepicker__day:hover {
  background: #fff7ed !important;
  color: #e85b28 !important;
}

/* Selected day */
.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background: #e85b28 !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.react-datepicker__day--selected:hover {
  background: #c44a1e !important;
  color: #fff !important;
}

/* Today */
.react-datepicker__day--today {
  font-weight: 700 !important;
  background: #fff7ed !important;
  color: #e85b28 !important;
  border: 2px solid #e85b28 !important;
}

.react-datepicker__day--today.react-datepicker__day--selected {
  background: #e85b28 !important;
  color: #fff !important;
  border-color: #e85b28 !important;
}

/* Range selection */
.react-datepicker__day--in-range,
.react-datepicker__day--in-selecting-range {
  background: #fed7aa !important;
  color: #92400e !important;
}

/* Outside month */
.react-datepicker__day--outside-month {
  color: #d1d5db !important;
}

/* Disabled */
.react-datepicker__day--disabled {
  color: #e2e8f0 !important;
}

/* Time panel */
.react-datepicker__time-container {
  border-left: 1px solid #f1f5f9 !important;
}

.react-datepicker__time-container .react-datepicker__header {
  background: #fff7ed !important;
}

.react-datepicker__time-list-item:hover {
  background: #fff7ed !important;
  color: #e85b28 !important;
}

.react-datepicker__time-list-item--selected {
  background: #e85b28 !important;
  color: #fff !important;
  font-weight: 600 !important;
}

/* Triangle/Arrow */
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: #e2e8f0 !important;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-bottom-color: #fff7ed !important;
}

/* Close/Clear button */
.react-datepicker__close-icon::after {
  background-color: #e85b28 !important;
  font-size: 12px !important;
  padding: 2px !important;
  line-height: 1 !important;
  border-radius: 50% !important;
  width: 18px !important;
  height: 18px !important;
}

.react-datepicker__close-icon:hover::after {
  background-color: #c44a1e !important;
}

/* Input styling when inside our branded areas */
.react-datepicker-wrapper {
  display: inline-block;
}

.react-datepicker-wrapper input.form-control {
  border-radius: 8px;
  font-size: 13px;
  padding: 8px 32px 8px 12px;
  border: 1px solid #e2e8f0;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.react-datepicker-wrapper input.form-control:focus {
  border-color: #e85b28;
  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.1);
  outline: none;
}

/* Month/Year dropdowns */
.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  background: #fff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.react-datepicker__month-option:hover,
.react-datepicker__year-option:hover {
  background: #fff7ed !important;
}

.react-datepicker__month-option--selected_month,
.react-datepicker__year-option--selected_year {
  color: #e85b28 !important;
  font-weight: 700 !important;
}`, "",{"version":3,"sources":["webpack://./src/style/datepicker-brand.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;iEAAA;AAGA;EACE,qBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;AAEF;AAAA;EACE,qBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;AAEF;AACA;;;iEAAA;AAKA,8DAAA;AACA;EACE,wBAAA;AAAF;;AAGA,WAAA;AACA;EACE,oCAAA;EACA,8BAAA;EACA,oDAAA;EACA,+BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,2CAAA;EACA,4BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;AAAF;;AAGA,sBAAA;AACA;EACE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA,cAAA;AACA;EACE,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,8BAAA;EACA,yBAAA;AAAF;;AAGA,iBAAA;AACA;;EAEE,8BAAA;EACA,sBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,8BAAA;EACA,sBAAA;AAAF;;AAGA,UAAA;AACA;EACE,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,8BAAA;EACA,sBAAA;EACA,gCAAA;AAAF;;AAGA,oBAAA;AACA;;EAEE,8BAAA;EACA,yBAAA;AAAF;;AAGA,kBAAA;AACA;EACE,yBAAA;AAAF;;AAGA,aAAA;AACA;EACE,yBAAA;AAAF;;AAGA,eAAA;AACA;EACE,yCAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,8BAAA;EACA,yBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,sBAAA;EACA,2BAAA;AAAF;;AAGA,mBAAA;AACA;EACE,uCAAA;AAAF;;AAEA;EACE,uCAAA;AACF;;AAEA,uBAAA;AACA;EACE,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA,gDAAA;AACA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,gDAAA;AACF;;AAEA;EACE,qBAAA;EACA,4CAAA;EACA,aAAA;AACF;;AAEA,yBAAA;AACA;;EAEE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,qDAAA;AACF;;AAEA;;EAEE,8BAAA;AACF;;AAEA;;EAEE,yBAAA;EACA,2BAAA;AACF","sourcesContent":["/* ============================================================\n   Nunito Font — used for CM Central branding\n   ============================================================ */\n@font-face {\n  font-family: 'Nunito';\n  src: url('./fonts/Nunito-Black.ttf') format('truetype');\n  font-weight: 900;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Nunito';\n  src: url('./fonts/Nunito-ExtraBold.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n/* ============================================================\n   DatePicker — Orange Brand Overrides\n   Applied globally to all react-datepicker instances\n   ============================================================ */\n\n/* Z-index fix for popper to appear above tables and headers */\n.react-datepicker-popper {\n  z-index: 9999 !important;\n}\n\n/* Header */\n.react-datepicker {\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;\n  font-family: inherit !important;\n  overflow: hidden;\n}\n\n.react-datepicker__header {\n  background: #fff7ed !important;\n  border-bottom: 1px solid #fed7aa !important;\n  padding-top: 12px !important;\n}\n\n.react-datepicker__current-month {\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #1e293b !important;\n}\n\n.react-datepicker__day-name {\n  color: #94a3b8 !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n}\n\n/* Navigation arrows */\n.react-datepicker__navigation-icon::before {\n  border-color: #e85b28 !important;\n}\n\n.react-datepicker__navigation:hover *::before {\n  border-color: #c44a1e !important;\n}\n\n/* Day cells */\n.react-datepicker__day {\n  border-radius: 8px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #374151 !important;\n  transition: all 0.1s !important;\n}\n\n.react-datepicker__day:hover {\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n}\n\n/* Selected day */\n.react-datepicker__day--selected,\n.react-datepicker__day--keyboard-selected {\n  background: #e85b28 !important;\n  color: #fff !important;\n  font-weight: 700 !important;\n}\n\n.react-datepicker__day--selected:hover {\n  background: #c44a1e !important;\n  color: #fff !important;\n}\n\n/* Today */\n.react-datepicker__day--today {\n  font-weight: 700 !important;\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n  border: 2px solid #e85b28 !important;\n}\n\n.react-datepicker__day--today.react-datepicker__day--selected {\n  background: #e85b28 !important;\n  color: #fff !important;\n  border-color: #e85b28 !important;\n}\n\n/* Range selection */\n.react-datepicker__day--in-range,\n.react-datepicker__day--in-selecting-range {\n  background: #fed7aa !important;\n  color: #92400e !important;\n}\n\n/* Outside month */\n.react-datepicker__day--outside-month {\n  color: #d1d5db !important;\n}\n\n/* Disabled */\n.react-datepicker__day--disabled {\n  color: #e2e8f0 !important;\n}\n\n/* Time panel */\n.react-datepicker__time-container {\n  border-left: 1px solid #f1f5f9 !important;\n}\n\n.react-datepicker__time-container .react-datepicker__header {\n  background: #fff7ed !important;\n}\n\n.react-datepicker__time-list-item:hover {\n  background: #fff7ed !important;\n  color: #e85b28 !important;\n}\n\n.react-datepicker__time-list-item--selected {\n  background: #e85b28 !important;\n  color: #fff !important;\n  font-weight: 600 !important;\n}\n\n/* Triangle/Arrow */\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n  border-bottom-color: #e2e8f0 !important;\n}\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::after {\n  border-bottom-color: #fff7ed !important;\n}\n\n/* Close/Clear button */\n.react-datepicker__close-icon::after {\n  background-color: #e85b28 !important;\n  font-size: 12px !important;\n  padding: 2px !important;\n  line-height: 1 !important;\n  border-radius: 50% !important;\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.react-datepicker__close-icon:hover::after {\n  background-color: #c44a1e !important;\n}\n\n/* Input styling when inside our branded areas */\n.react-datepicker-wrapper {\n  display: inline-block;\n}\n\n.react-datepicker-wrapper input.form-control {\n  border-radius: 8px;\n  font-size: 13px;\n  padding: 8px 32px 8px 12px;\n  border: 1px solid #e2e8f0;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.react-datepicker-wrapper input.form-control:focus {\n  border-color: #e85b28;\n  box-shadow: 0 0 0 3px rgba(232, 91, 40, 0.1);\n  outline: none;\n}\n\n/* Month/Year dropdowns */\n.react-datepicker__month-dropdown,\n.react-datepicker__year-dropdown {\n  background: #fff !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;\n}\n\n.react-datepicker__month-option:hover,\n.react-datepicker__year-option:hover {\n  background: #fff7ed !important;\n}\n\n.react-datepicker__month-option--selected_month,\n.react-datepicker__year-option--selected_year {\n  color: #e85b28 !important;\n  font-weight: 700 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
